module.exports = __webpack_public_path__ + "img/img96.e33a49b2.jpg";